import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/colorgrid/colortile
 */
import ButtonView from "../button/buttonview";
import checkIcon from "../../theme/icons/color-tile-check.svg";
/**
 * This class represents a single color tile in the {@link module:ui/colorgrid/colorgrid~ColorGridView}.
 *
 * @extends module:ui/button/buttonview~ButtonView
 */

var ColorTileView =
/*#__PURE__*/
function (_ButtonView) {
  _inherits(ColorTileView, _ButtonView);

  function ColorTileView(locale) {
    var _this;

    _classCallCheck(this, ColorTileView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorTileView).call(this, locale));
    var bind = _this.bindTemplate;
    /**
     * String representing a color shown as tile's background.
     *
     * @type {String}
     */

    _this.set('color');
    /**
     * A flag that toggles a special CSS class responsible for displaying
     * a border around the button.
     *
     * @type {Boolean}
     */


    _this.set('hasBorder');

    _this.icon = checkIcon;

    _this.extendTemplate({
      attributes: {
        style: {
          backgroundColor: bind.to('color')
        },
        class: ['ck', 'ck-color-grid__tile', bind.if('hasBorder', 'ck-color-table__color-tile_bordered')]
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ColorTileView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ColorTileView.prototype), "render", this).call(this);

      this.iconView.fillColor = 'hsl(0, 0%, 100%)';
    }
  }]);

  return ColorTileView;
}(ButtonView);

export { ColorTileView as default };